<template>
	<v-container grid-list-xl pb-0>
		<ReportForm
			:edit-report="editReport"
			@update-report="updateReport"
		>
			<v-btn
				v-if="closable"
				slot="buttons"
				flat
				color="error"
				@click="$emit('cancel')"
			>
				Close
			</v-btn>
		</ReportForm>
		<v-divider class="mt-2"/>
		<ImageUpload :item="editReport" @upload="$emit('cancel')" />
	</v-container>
</template>

<script>
import ReportForm from '@/components/Report/ReportForm';
import ImageUpload from '@/components/ImageUpload';

export default {
	components: {
		ReportForm,
		ImageUpload,
	},
	props: {
		editReport: { type: Object, default: null },
		closable: { type: Boolean, default: true },
	},
	computed: {
		allArticlesImages() {
			return this.$store.get('articles').map(a => a.image);
		},
	},
	methods: {
		updateReport(report, oldName) {
			report.save().then(() => {
				this.$notify('success', `Report "${report.displayName}" has been updated.`);
			}).catch((error) => {
				// Validation error can only occur if the name, date, project combo already was taken
				if (error.response.response.status === 422) {
					this.$notify('error', 'The combination of Name, Date, and Project has already been taken.');
					report.name = oldName;
					return;
				}
				this.$notify('error', `Failed to rename report "${oldName}".`);
			}).finally(() => {
				this.$emit('saving-done');
			});
		},
	},
};
</script>
